import {
  SEND_CAMPAIGN,
  SEND_CAMPAIGN_FAILED,
  DELETE_CAMPAIGN_SUCCESSFUL,
  DELETE_CAMPAIGN_FAILED,
  DRAFT_CAMPAIGN
} from "../actions/types";
import { message } from "antd";

const IntialState = {
  campaignError: null,
  type: null,
  campaignSend: null
};

export default (state = IntialState, action) => {
  switch (action.type) {
    case SEND_CAMPAIGN:
      message.success("Campaign sent successfully", 5);
      return state;
    case DRAFT_CAMPAIGN:
        message.success("Campaign saved to draft", 5);
      return state
    case SEND_CAMPAIGN_FAILED:
      message.error("Campaign email failed", 5);
      return state;
    case DELETE_CAMPAIGN_SUCCESSFUL:
      return state;
    case DELETE_CAMPAIGN_FAILED:
      return {
        ...state,
        campaignError: "Deleting campaign failed",
        type: "error"
      };
    default:
      return state;
  }
};
